<template>
  <b-dropdown
    block
    :text="selected"
    class="dropdown--dropselect fontselect form-control"
    :style="{ fontFamily: selected }"
    variant="dropselect"
    :disabled="disabled"
  >
    <div class="option-list-wrap">
      <overlay-scrollbars :options="scrollBarsOptions" ref="dropselectScrollBar" class="dropselect-scrollbar">
        <b-dropdown-group v-if="options.length > 0" class="option-list">
          <b-dropdown-item 
            v-for="(item, index) in options" :key="'font-' + index"
            class="list-item"
            :style="{ fontFamily: item }"
            @click="selectOption(item)"
          >
            {{ item }}
          </b-dropdown-item>
        </b-dropdown-group>
      </overlay-scrollbars>
    </div>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FontSelector",
  props: {
    preselect: {
      type: String,
      default: null
    },
    searchable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      next: null,
      options: [],
      selected: '',
      scrollBarsOptions: {
        scrollbars: { autoHide: 'never' },
        overflowBehavior: { y: 'scroll', x: 'hidden' }
      }
    }
  },
  computed: {
    ...mapGetters({ 
      defaultFonts: "invoicesLayout/getDefaultFonts"
    })
  },
  watch: {
    preselect (newValue, oldValue) {
      this.setSelected(newValue)
    }
  },
  created () {
    this.loadWebFonts()
    this.init()
  },
  mounted () {
  },
  methods: {
    loadWebFonts () {
      this.$webfontloader.load({
        google: {
          families: this.defaultFonts['GoogleWebFonts'],
        },
        active: () => {
          this.loaded = true
        },
      })
    },
    init () {
      this.options = this.defaultFonts['GoogleWebFonts']
      this.setSelected(this.preselect)
    },
    setSelected (selected) {
      if(selected && selected === 'DINNextLTPro-Regular,sans-serif') {
        this.selected = this.$gettext('Default')
      } else {
        this.selected = selected
      }
    },
    selectOption (selected_item) {
      this.selected = selected_item
      this.$emit('selected-font', this.selected)
    }
  },
}
</script>

<style lang="scss" scoped>
</style>